function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "m16.3 1.6c-1.5-1.4-3.8-1.5-5.3 0s-1.5 3.8 0 5.3l18.4 18.4-18.3 18.4c-1.5 1.5-1.5 3.8 0 5.3.7.7 1.7 1.1 2.6 1.1s1.9-.4 2.6-1.1l23.7-23.8z",
  className: "o-icon__path"
});

var SvgAngleRight = function SvgAngleRight(props) {
  return React.createElement("svg", _extends({
    enableBackground: "new 0 0 50 50",
    viewBox: "0 0 50 50",
    className: "o-icon o-icon-small"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MCA1MCIgdmlld0JveD0iMCAwIDUwIDUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJvLWljb24gby1pY29uLXNtYWxsIj48cGF0aCBkPSJtMTYuMyAxLjZjLTEuNS0xLjQtMy44LTEuNS01LjMgMHMtMS41IDMuOCAwIDUuM2wxOC40IDE4LjQtMTguMyAxOC40Yy0xLjUgMS41LTEuNSAzLjggMCA1LjMuNy43IDEuNyAxLjEgMi42IDEuMXMxLjktLjQgMi42LTEuMWwyMy43LTIzLjh6IiBjbGFzcz0iby1pY29uX19wYXRoIiAvPjwvc3ZnPg==";
export { SvgAngleRight as ReactComponent };